import { AxiosRequestConfig } from 'axios';

declare global {
  interface WURFL {
    /* eslint-disable-next-line camelcase */
    form_factor: string;
  }

  interface Window {
    WURFL: WURFL;
  }
}

const getCookie = (name: string) => {
  const regexp = new RegExp(`(?:^${name}|; *${name})=(.*?)(?:;|$)`, 'g');
  const result = regexp.exec(document.cookie);
  return result === null ? null : result[1];
};

const getBcId = () => getCookie('BrowserCookieId');

type InterceptorOptions = { allowedUrls: string[]; appVersion: string };

const makeAnalyticsInterceptor = ({ allowedUrls, appVersion }: InterceptorOptions) => (
  request: AxiosRequestConfig
) => {
  if (allowedUrls.some(url => !request.url?.includes(url))) {
    return request;
  }

  const platform = getCookie('X-CVNA-DeviceType') ?? 'Web';
  const appVersionHeader = platform === 'Web' ? appVersion : getCookie('X-CVNA-AppVersion');
  const bcid = getBcId();
  /* eslint-disable-next-line camelcase */
  const deviceType = platform === 'Web' ? window.WURFL?.form_factor : platform;

  request.headers['X-CVNA-Platform'] = platform;
  request.headers['X-CVNA-AppVersion'] = appVersionHeader;
  request.headers['X-CVNA-DeviceType'] = deviceType;

  if (platform === 'Web') {
    request.headers['X-CVNA-BrowserCookieId'] = bcid;
  } else {
    request.headers['X-CVNA-DeviceId'] = getCookie('X-CVNA-DeviceId');
  }

  return request;
};

export default makeAnalyticsInterceptor;
